import http from '../common/compornents/httpcommon';

class NonyusakiSearchServ {

  getNonyusakiSearchData = (params: any) => {
    return http.get('getNonyusakiSearchData/', { params });
  };

}

export default new NonyusakiSearchServ();
